
import { handleBreakpoints } from "@mui/system";
import axios from "axios";

import React, { useState, useEffect } from "react";
import { ModalFooter } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import "./Header.css";

const Header =(props) =>{
const [showNav,setShowNav] = useState(true);

const handleClose = () => {
    
    
    ToggleHamburger();
    setShowNav(false);
    };
const handleShow = () => {
    ToggleHamburger();
    setShowNav(true);

    };

useEffect(()=>{
    if(window.location.href.toLowerCase().indexOf("termsofuse.aspx")>0){
        if(window.screen.width>768){
        document.getElementsByClassName("mashan-rich-text")[0].style.marginTop="-450px";
        }else{
            document.getElementsByClassName("mashan-rich-text")[0].style.marginTop="-200px";
        }
    }
        UpdateNavigation2();
},[]);
const CloseNavigationModal = (e)=>{
              
    let navigationModal = document.getElementById("navigation-modal-id");
              let subMenuNav = document.getElementsByClassName("narrowUl dropdown-menu");

           document.getElementsByTagName('body')[0].style.overflowY='auto';         
           navigationModal.classList.remove('show');
           document.getElementById("masterpage-right-area-id").classList.remove('d-none');               
           
           document.getElementById("footerMashanWrapId").classList.remove('d-none');
        if(!!document.getElementById("main-page-2")){
           document.getElementById("main-page-2").classList.remove('d-none');  
                    if (!!subMenuNav) {
                        for (let item of subMenuNav) {
                            RemoveShow(item);
                        }
                    }
                }
                else{
                    document.getElementById("mashan-search-results-id").classList.remove('d-none');  
                }
                document.getElementsByClassName('pagination-ul')[0].classList.remove('d-none');
};
const HandleKeyDownSearchNavigationPage =(eve)=>{
    if(eve.key==='Enter'){
        ExecuteSearchSearchPage( eve.target.value);
    }
};
const HandleKeyDownGlassNavigationPage =(eve)=>{
       if(eve.key==='Enter'){
           ExecuteSearchSearchPage( eve.target.previousElementSibling.value);
       }
};
const HandleKeyDownCloseHamburger =(eve)=>{
    if(eve.key==='Enter'){
        CloseNavigationModal( eve);
    }
};

const UpdateNavigation2=()=> {
   
    setTimeout(function(){
    
    if (document.getElementsByClassName('nav-section').length > 0) {
        let sections = document.getElementsByClassName('nav-section');
        let ulWarpper = document.getElementsByClassName('pagination-ul')[0];
        let tempTxt = '01';
        for (let sectionI = 0; sectionI < sections.length; sectionI++) {
           ulWarpper.insertAdjacentHTML('beforeEnd',`<li><a class="indicator ${!tempTxt ? '' : 'active' }" href="#${sections[sectionI].id}" id="${sections[sectionI].id}-nav">${tempTxt}</a></li>`);
           tempTxt='';
        }
    }},2000);
    
};
function IsInViewport(el){
    
    if(!el){
        return false;
    }
    const rect = el.getBoundingClientRect();
 
    return(
        window.pageYOffset ==0 ||
         window.pageYOffset/rect.y==0 ||
          (0.35<=window.pageYOffset/rect.y)
  
    )
};

const UpdateNavigaionElements=(activeEleIdx)=>{
    let paginationUl =document.getElementsByClassName('pagination-ul');
    if(paginationUl.length>0){
    const childLi =paginationUl[0].children;
    if(childLi){
          for(let tchildIdx=0;tchildIdx<childLi.length;tchildIdx++){
            if(tchildIdx===activeEleIdx){
                let tempNum=tchildIdx+1;
                childLi[tchildIdx].children[0].classList.add('active');
               childLi[tchildIdx].children[0].innerText= '0'+tempNum;
                
            }
            else{
                childLi[tchildIdx].children[0].classList.remove('active');
                childLi[tchildIdx].children[0].innerText='';
            }
//        });
    }
    }
    }

};

const CustomScroll =()=>{
    if (window.innerWidth > 1050) {
    let div1 = 'main-page-1';
    let div2 = 'nav-section-0';
    let div3 = 'nav-section-1';
    let div4 = 'nav-section-2';
    let tempDiv = '';

    if(IsInViewport(document.getElementById(div1))){
        //document.getElementById(div1+'-nav').classList('active');
      //  document.getElementById(div1+'-nav').insertAdjacentText('beforeEnd','01');
      UpdateNavigaionElements(0);
       
    }
    else if (IsInViewport(document.getElementById(div2))){
        UpdateNavigaionElements(1);
    }
    else if (IsInViewport(document.getElementById(div3))){
        UpdateNavigaionElements(2);
    }
    else if (IsInViewport(document.getElementById(div4))){
        UpdateNavigaionElements(3);
    }
    let customNavPagination = document.getElementById('hamburger-warrper-id');
    let customNavPaginationRect = customNavPagination.getBoundingClientRect();
    
    if(window.pageYOffset>customNavPaginationRect.height + 600){
        customNavPagination.classList.add('pin-hamburger');
      }else{
        customNavPagination.classList.remove('pin-hamburger');
      }
      let footerEle = document.getElementById("footerMashanWrapId");
      let paginationEle = document.getElementById('custom-nav-pagination');
      if(0.65 < window.scrollY/footerEle.offsetTop && !!paginationEle){
        paginationEle.style.position="absolute";
        paginationEle.style.top=window.scrollY+150+"px";
      }else if(!!paginationEle){
        paginationEle.style.position="fixed";
        paginationEle.style.top="55%";
      }
    }
};
document.addEventListener('scroll', CustomScroll,{passive:true});
   
    return (
        <div className="col-12 col-lg-12">
             
            <div className="master-header col-12">
            {/* col-2 */}
       <div className="col-3 col-md-1 hamburger-warrper ">
      
            <div className='col-1'></div>
           <a className="hamburger-close hamburger-client dropdown col-4"  type="button"  onClick={(e)=>CloseNavigationModal(e)} 
                onKeyDown={e=>{HandleKeyDownCloseHamburger(e)}} tabIndex="0"
           
           ></a>
      </div>
                 <div className="fade modal-backdrop modal fade " aria-hidden="true" aria-modal="true"></div>
                              
                 {/* col-7  */}
       <div className="left-area mx-auto mx-md-0 justify-content-md-end  col-6 col-md-4 col-xl-2">
       <a href="https://mod.gov.il" title="MOD Home" className="state-logo col-6 col-md-6 col-xl-4">
       </a>
           <a href="https://mission-ny.mod.gov.il" title="Mashan Home" className="dept-logo col-6 col-md-6 col-xl-4"></a>
       </div>
       <div className="col-md-2 col-xl-5 d-none d-lg-block"></div>
			<div className="right-area col-3 col-md-3 ">
            <div className="search col-9 ">
                <input type="search" className="search-box-input" id="search-box-input"  onKeyDown={e=>{HandleKeyDownSearchNavigationPage(e)}} tabIndex="0" />
                <a type="search" className="search-box" onClick={(e)=>ExecuteSearch(e)}  onKeyDown={e=>{HandleKeyDownGlassNavigationPage(e)}} tabIndex="0"></a>
            </div>
            <a className="person" href="https://online.mod.gov.il/eng/pages/general/info/start.aspx"></a>
        </div>

{/* </div> */}
       </div>
   </div>
       
    );
};
export default Header;